import { Event } from '../../../types/event';
import { Membership } from '../../../types/membership';
import { Ticket } from '../../../types/ticket';
import { DefaultStrategy } from './default';
import { MembershipBahiaStrategy, EsquadraoNaFonteStrategy } from './membershipBahiaRules';
import { MembershipBotafogoStrategy } from './membershipBotafogoRules';
export class ValidationContext {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  strategies: any[];
  constructor() {
    this.strategies = [
      new EsquadraoNaFonteStrategy(),
      new MembershipBahiaStrategy(),
      new MembershipBotafogoStrategy(),
      new DefaultStrategy(),
    ];
  }

  validate(membershipApplied: Membership | null, cart: Ticket[], event: Event | null,
    tickets: Ticket[], groupId: number, ticketId: number, totalTickets : number) {
    const strategy = this.strategies.find((s) => s.shouldApply(membershipApplied, event));
    return strategy.validate(membershipApplied, cart, event, tickets, groupId, ticketId, totalTickets);
  }

}
